import React, { useRef, useState } from "react";
import "./provider.css";
import { ArrowRight, Fullscreen } from "@mui/icons-material";

const Provider = ({ vid, main, sub, dir = false }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);

  const togglePlayPause = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const toggleFullScreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.mozRequestFullScreen) {
        videoRef.current.mozRequestFullScreen();
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    }
  };

  return (
    <div
      className="pvx-provider"
      style={dir ? { flexDirection: "row-reverse" } : {}}
    >
      <div className="vidBox">
        <div className="vidBG"></div>
        <video
          ref={videoRef}
          className="vid"
          onClick={togglePlayPause}
          onMouseEnter={() => setFullScreen(true)}
          onMouseLeave={() => setFullScreen(false)}
        >
          <source src={vid} type={"video/mp4"} />
          Your browser does not support the video tag.
        </video>

        {/* Video Controls  */}
        {!isPlaying && (
          <div className="pauseBtn">
            <div className="btnRing">
              <ArrowRight onClick={togglePlayPause} />
            </div>
          </div>
        )}
        {fullScreen && isPlaying && (
          <div className="fsBtn">
            <Fullscreen
              onClick={toggleFullScreen}
              onMouseEnter={() => setFullScreen(true)}
              onMouseLeave={() => setFullScreen(false)}
            />
          </div>
        )}
      </div>
      <div className="content">
        <div className="main">{main}</div>
        <div className="sub">{sub}</div>
      </div>
    </div>
  );
};

export default Provider;
